import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials, type Testimonial } from '../data/testimonials';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  return <section aria-labelledby="testimonials-heading" className="w-full bg-plum text-white" data-id="element-252" data-mp="3fyvy6aic1db3">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-20" data-id="element-253" data-mp="3azjcht376ca3">
        <div className="text-center" data-id="element-254" data-mp="36yzgwty9vgq2">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-255" data-mp="3700pmrrtfr4m">
            Coach to coach
          </p>
          <h2 id="testimonials-heading" className="mt-3 font-display text-3xl font-semibold uppercase leading-tight md:text-5xl" data-id="element-256" data-mp="31yl6j5977uov">
            One room, two tracks, <span className="text-gold" data-id="element-257" data-mp="2s39reltvolgl">no waiting.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-258" data-mp="v8591v8ft91q">
          {testimonials.map(item => <li key={item.author} data-id="element-259" data-mp="qavanq32ln1r">
              <figure className="flex h-full flex-col rounded-xl border border-plum-line bg-plum-card p-5 md:p-6" data-id="element-260" data-mp="q8irxaphn8nn">
                <span className="flex gap-0.5" role="img" aria-label="Rated 5 out of 5" data-id="element-261" data-mp="m4ro4cnjve6f">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-262" data-mp="79260plhjl6z" />)}
                </span>
                <blockquote className="mb-6 mt-4 text-lg leading-snug text-white" data-id="element-263" data-mp="zyivpfhq0nzi">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 border-t border-plum-line pt-4" data-id="element-264" data-mp="q7eiolblvd7b">
                  <Avatar item={item} data-id="element-265" data-mp="v4xuzfoqtfwm" />
                  <span className="min-w-0 text-xs leading-relaxed text-white/60" data-id="element-266" data-mp="v3wmniz437il">
                    <span className="block text-sm font-semibold text-white" data-id="element-267" data-mp="1itqwdro4wfym">
                      {item.author}
                    </span>
                    {item.role}
                    <span className="block" data-id="element-268" data-mp="1xi92j8t01dd0">{item.location}</span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function Avatar({
  item
}: {
  item: Testimonial;
}) {
  if (item.avatar) {
    return <img src={item.avatar} alt={item.author} width={48} height={48} loading="lazy" className="h-12 w-12 flex-none rounded-full object-cover ring-2 ring-gold/60" data-id="element-269" data-mp="1jj0xhza5nb0w" />;
  }
  const initials = item.author.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  return <span aria-hidden="true" className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-gold font-display text-base font-semibold text-gold-ink" data-id="element-270" data-mp="10s9t7c50yatd">
      {initials}
    </span>;
}